import React from "react";
import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import PageRoutes from "../../utils/routes";

const Missing = () => {
  const handleGoBack = () => {
    window.history.back(); // Tarayıcı geçmişini kullanarak bir önceki sayfaya dön
  };

  return (
    <Result
      status="404"
      title="Sayfa Bulunamadı"
      subTitle="Erişmek istediğiniz sayfa bulunamadı."
      extra={
        <div>
          <Button type="default" onClick={handleGoBack}>
            Geri Dön
          </Button>
          <div style={{ width: "10px", display: "inline-block" }} />
          <Link to={PageRoutes.home}>
            <Button type="primary">Ana Sayfa</Button>
          </Link>
        </div>
      }
    />
  );
};

export default Missing;
